import React, { useState } from "react";
import { Box, Typography, IconButton } from "@mui/material";
// Styles
import { styles } from "./styles";
// Components
import { APP_VERSION } from "config";
import { LanguageSelector } from "Components/Language/languageSelector";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import LanguageIcon from "@mui/icons-material/Language";
// i18n
import { useTranslation } from "react-i18next";

export const AuthFooter = ({ showCopyright = true }) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpenLanguage = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseLanguage = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={styles.footerBox}>
      <address style={styles.techSupport} align="center">
        {t("footer.techSupportPrompt", "For technical support, email us at")}{" "}
        <a href="mailto:techsupport@medinav.ca" style={styles.email}>
          techsupport@medinav.ca
        </a>
      </address>
      {showCopyright && (
        <Box sx={styles.versionLanguageBox}>
          <Typography sx={styles.version}>Version: {APP_VERSION}</Typography>
          <IconButton onClick={handleOpenLanguage} sx={styles.iconButton}>
            <LanguageIcon />
            <Typography variant="body2" sx={{ paddingLeft: 2.5 }}>
              {t("common.language")}
            </Typography>
            <ArrowDropDownIcon fontSize="small" />
          </IconButton>
          <LanguageSelector
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleCloseLanguage}
          />
        </Box>
      )}
    </Box>
  );
};
